module.exports = __webpack_public_path__ + "media/components/wind-icon/static/NNW@2x-09c22d8eff42900f1a4e3fe1a645c03b.png";